import { createReducer, on } from '@ngrx/store';
import { pageLoadingFinish, pageLoadingStart } from '../actions/page-loading.actions';
import { PageLoadingState } from '../models/assessment-models';

export const initialPageLoadingState: PageLoadingState = {
  loadingData: {
    loading: false,
    description: '',
    nextButton: true,
    repeatButton: false,
    submitButton: false,
    startTestButton: false,
  },
};

export const pageLoadingReducer = createReducer(
  initialPageLoadingState,
  on(pageLoadingStart, (state, { description }) => ({
    ...state,
    loadingData: {
      loading: true,
      description: description,
      nextButton: false,
      repeatButton: false,
      submitButton: false,
      startTestButton: false,
    },
  })),
  on(pageLoadingFinish, (state) => ({
    ...state,
    loadingData: {
      loading: false,
      description: '',
      nextButton: true,
      repeatButton: false,
      submitButton: false,
      startTestButton: false,
    },
  })),
);
